import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { routes } from "../../routes/routes";
import { getUserAvatar } from "../../utils/getMedia";
import { iconsImgs } from "../../utils/icons";
import Gender from "../../api/enums/Gender";
import Header from "../Header";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { usePromoterSelectedGroup } from "../../hooks/usePromoterSelectedGroup";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import PromoterGroupActions from "../PromoterGroups/PromoterGroupActions";

const PromoterGroupPhotos = () => {
    const { city, groupId } = useParams();
    const { selectedGroup, requestState } = usePromoterSelectedGroup(groupId);

    const invitations = useMemo(
        () => selectedGroup?.invitations ?? [],
        [selectedGroup]
    );
    const returnTo = routes.PromGroupPhotosPage(city ?? "", groupId ?? "");
    const getInvitationFallbackImage = (gender: Gender) =>
        gender === Gender.Male ? iconsImgs.Boy_96x96 : iconsImgs.Girl_96x96;

    return (
        <>
            <Header />
            <div className="centerGroup">
                <div className="desktopUI">
                    <div className="row userProfile_Header">
                        <Breadcrumbs to={routes.PromotersMode} />
                        <PromoterGroupActions
                            city={city}
                            groupId={groupId}
                            groupStatus={selectedGroup?.party.status}
                            returnTo={returnTo}
                        />
                    </div>
                    {invitations.length > 0 ? (
                        <div>
                            <div className="groupPromoter">
                                <div className="desktopUI">
                                    <Carousel
                                        className={`row mt-4 swipe-container`}
                                        swipeable
                                        emulateTouch
                                        showArrows={false}
                                        infiniteLoop={true}
                                        showStatus={false}
                                        renderIndicator={() => null}
                                        swipeScrollTolerance={100}
                                        showThumbs={false}
                                    >
                                        {invitations.map((invitation, index) => (
                                            <div key={invitation.id} className="carousel-slide p-0 m-0">
                                                <div className="col-12">
                                                    <p className="yellowTxt m-0">Age: {invitation.age}</p>
                                                    <p className="yellowTxt m-0">
                                                        Tap on the picture to enable pinch zoom
                                                    </p>
                                                    <p className="yellowTxt">Swipe to see next guest</p>
                                                </div>

                                                <div className="col-12 justify-content-center align-content-center p-0">
                                                    <div className="promoter-imageContainer">

                                                        {Array.from({ length: Math.max(invitation.photos, 1) }, (_, i) => {
                                                            const photoKey =
                                                                i === 0 ? invitation.id : `${invitation.id}${i}`;
                                                            const photoSrc = getUserAvatar(photoKey);
                                                            const fallbackSrc = getInvitationFallbackImage(invitation.gender);
                                                            const hasUploadedPhotos = invitation.photos > 0;
                                                            const zoomPhotoParam = hasUploadedPhotos
                                                                ? photoSrc
                                                                : invitation.gender === Gender.Male
                                                                  ? "male"
                                                                  : "female";

                                                            return (
                                                                <Link
                                                                    to={routes.PhotoZoom(
                                                                        "promoter-group-photo",
                                                                        city ? city : "0",
                                                                        groupId ? groupId : invitation.id,
                                                                        `${index}?photo=${zoomPhotoParam}`
                                                                    )}
                                                                    key={`${invitation.id}-${i}`}
                                                                >
                                                                    <img
                                                                        src={hasUploadedPhotos ? photoSrc : fallbackSrc}
                                                                        alt=""
                                                                        style={{ pointerEvents: "all" }}
                                                                        className="p-0 m-0 groupDetailImg"
                                                                        onError={(event) => {
                                                                            event.currentTarget.onerror = null;
                                                                            event.currentTarget.src = fallbackSrc;
                                                                        }}
                                                                    />
                                                                </Link>
                                                            );
                                                        })}

                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Carousel>
                                </div>
                            </div>
                        </div>
                    ) : requestState === "loading" || requestState === "idle" ? (
                        <p>Loading group...</p>
                    ) : requestState === "error" ? (
                        <p>Group not found.</p>
                    ) : (
                        <p>Invitation not found.</p>
                    )}
                </div>
            </div>
            <ToastContainer
                progressClassName="toastProgress"
                bodyClassName="toastBody"
            />
        </>
    );
};

export default PromoterGroupPhotos;
